import { Body, Box, Heading } from '@hover/blueprint';
import { iMail } from '@hover/icons';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { ButtonLink, Link } from 'src/shared/components/Link';
import {
  TranslationNamespace,
  useEffectOnMount,
  useTranslate,
} from 'src/shared/hooks';
import { Route as Routes } from 'src/shared/route';
import { buttonPressed, pageViewed } from 'src/shared/telemetry';

export const Welcome = ({ isLogin = false }) => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const { search } = useLocation();

  const pageOrScreenName = isLogin ? 'Login_input' : 'Signup_type_input';

  useEffectOnMount(() => {
    pageViewed({
      page_or_screen_name: pageOrScreenName,
      feature: 'onboarding',
    });
  });

  return (
    <Box
      alignItems="center"
      height="100vh"
      justifyContent="center"
      p={{ base: 500, tablet: 600 }}
    >
      <Box flexDirection="column">
        <Heading
          color="neutral700"
          fontWeight="headingLight"
          size={{ base: 700, tablet: 900 }}
          testId="welcome-heading"
          textAlign="center"
        >
          {isLogin
            ? t('onboarding.welcomeBack')
            : t('onboarding.createAnAccount')}
        </Heading>
        <ButtonLink
          aria-label={t('onboarding.continueWithEmail')}
          fill="outline"
          iconBefore={iMail}
          onClick={() =>
            buttonPressed({
              button_text: 'Continue with Email',
              page_or_screen_name: pageOrScreenName,
              feature: 'onboarding',
            })
          }
          p={400}
          testId="continue-with-email"
          textDecoration="none"
          to={`${Routes.SIGN_UP_ONBOARDING.path}/login${search}`}
          width="100%"
        >
          <Body marginLeft={400}>{t('onboarding.continueWithEmail')}</Body>
        </ButtonLink>
        <Body m={400} testId="use-sso" textAlign="center">
          <Link
            color="neutral.700"
            onClick={() =>
              buttonPressed({
                button_text: 'Use Single Sign On',
                page_or_screen_name: pageOrScreenName,
                feature: 'onboarding',
              })
            }
            textDecoration="underline"
            to={`${Routes.SIGN_UP_ONBOARDING.path}/login/sso${search}`}
          >
            {t('onboarding.useSSO')}
          </Link>
        </Body>
        <Body testId="signup-login-link" textAlign="center">
          {isLogin ? (
            <>
              {t('onboarding.dontHaveAcc')}
              <Link
                color="neutral.700"
                ml={100}
                onClick={() =>
                  buttonPressed({
                    button_text: 'Sign up',
                    page_or_screen_name: pageOrScreenName,
                    feature: 'onboarding',
                  })
                }
                textDecoration="underline"
                to={`${Routes.SIGN_UP_ONBOARDING.path}/signup`}
              >
                {t('onboarding.signup')}
              </Link>
            </>
          ) : (
            <>
              {t('onboarding.haveAnAccount')}
              <Link
                color="neutral.700"
                ml={100}
                onClick={() =>
                  buttonPressed({
                    button_text: 'Log in',
                    page_or_screen_name: pageOrScreenName,
                    feature: 'onboarding',
                  })
                }
                textDecoration="underline"
                to={`${Routes.SIGN_UP_ONBOARDING.path}/login${search}`}
              >
                {t('onboarding.login')}
              </Link>
            </>
          )}
        </Body>
      </Box>
    </Box>
  );
};
